
import { SampleDetails } from '@/interfaces/samples';
import { MutationTree } from 'vuex';


const mutation: MutationTree<SampleDetails> = {

    setSampleId(state, sampleId) {
        state.sampleId = sampleId;
    },
    setSampleName(state, nombre) {
        state.nombre = nombre;
    },
    setSampleClientId(state, clientId) {
        state.clientId = clientId;
    },
    setSampleProjectId(state, projectId) {
        state.projectId = projectId;
    },
    setFechaCreacion(state, fecha_creacion) {
        state.fecha_creacion = fecha_creacion;
    },
    setIdConfFilesGrupo(state, id_conf_files_grupo) {
        state.id_conf_files_grupo = id_conf_files_grupo;
    },
    setEjecucion(state, ejecucion) {
        state.ejecucion = ejecucion;
    },
    setSampleTotal(state, sampleTotal) {
        state.sampleTotal = sampleTotal;
    },
    setSampleReview(state, sampleReview) {
        state.sampleReview = sampleReview;
    },
    setEditSample(state, editSample) {
        state.editSample = editSample;
    },
    setDeleteUnreviewed(state, deleteUnreviewed) {
        state.deleteUnreviewed = deleteUnreviewed;
    },
    setShowAddDocTypesModal(state, showAddDocTypesModal) {
        state.showAddDocTypesModal = showAddDocTypesModal;
    },
    setReloadSamplesList(state, reloadSamplesList) {
        state.reloadSamplesList = reloadSamplesList;
    }

}


export default mutation;